<template>
  <div class="app-container">
    <div class="filter-container">
      <el-input @keyup.enter.native="handleFilter" style="width: 200px;" class="filter-item"
                placeholder="角色名称"
                v-model="listQuery.roleName">
      </el-input>
<!--      <el-input @keyup.enter.native="handleFilter" style="width: 200px;" class="filter-item"-->
<!--                placeholder="备注"-->
<!--                v-model="listQuery.remark">-->
<!--      </el-input>-->
<!--      <el-input @keyup.enter.native="handleFilter" style="width: 200px;" class="filter-item"-->
<!--                placeholder="创建者ID"-->
<!--                v-model="listQuery.createUserId">-->
<!--      </el-input>-->
<!--      <el-input @keyup.enter.native="handleFilter" style="width: 200px;" class="filter-item"-->
<!--                placeholder="部门ID"-->
<!--                v-model="listQuery.deptId">-->
<!--      </el-input>-->
<!--      <el-date-picker-->
<!--        v-model="listQuery.createTime"-->
<!--        type="datetimerange"-->
<!--        range-separator="至"-->
<!--        start-placeholder="开始日期"-->
<!--        end-placeholder="结束日期">-->
<!--      </el-date-picker>-->

      <el-button class="filter-item" style="margin-left: 10px;" type="primary" v-waves icon="el-icon-search" @click="handleFilter">查找
      </el-button>
      <el-button class="filter-item" style="margin-left: 10px;" @click="handleCreate" type="primary"
                 icon="el-icon-edit">添加
      </el-button>
<!--      <el-button class="filter-item" type="primary" :loading="downloadLoading" v-waves icon="el-icon-download"-->
<!--                 @click="handleDownload">导出-->
<!--      </el-button>-->
    </div>

    <el-table :key='tableKey' :data="list" v-loading="listLoading" border fit highlight-current-row
              style="width: 100%;min-height:1000px;">
      <el-table-column align="center" label="序号">
        <template slot-scope="scope">
          <span>{{scope.row.roleId}}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="角色名称">
        <template slot-scope="scope">
          <span>{{scope.row.roleName}}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="备注">
        <template slot-scope="scope">
          <span>{{scope.row.remark}}</span>
        </template>
      </el-table-column>
<!--      <el-table-column align="center" label="创建者ID">-->
<!--        <template slot-scope="scope">-->
<!--          <span>{{scope.row.createUserId}}</span>-->
<!--        </template>-->
<!--      </el-table-column>-->
<!--      <el-table-column align="center" label="部门ID">-->
<!--        <template slot-scope="scope">-->
<!--          <span>{{scope.row.deptId}}</span>-->
<!--        </template>-->
<!--      </el-table-column>-->
      <el-table-column align="center" label="创建时间">
        <template slot-scope="scope">
          <span>{{parseTime(scope.row.createTime)}}</span>
        </template>
      </el-table-column>

      <el-table-column align="center" label="操作" width="230" class-name="small-padding fixed-width">
        <template slot-scope="scope">
          <el-button type="primary" size="mini" @click="handleUpdate(scope.row)">编辑</el-button>
          <el-button v-if="scope.row.status!='deleted'" size="mini" type="danger"
                     @click="handleDelete(scope.row)">删除
          </el-button>
        </template>
      </el-table-column>

    </el-table>

    <div class="pagination-container">
      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
                     :current-page="listQuery.page" :page-sizes="[10,20,30, 50]" :page-size="listQuery.limit"
                     layout="total, sizes, prev, pager, next, jumper" :total="total">
      </el-pagination>
    </div>

    <el-dialog   :title="textMap[dialogStatus]" :visible.sync="dialogFormVisible">
      <el-form :rules="rules" ref="dataForm" :model="temp" label-position="left" label-width="70px" style='width: 400px; margin-left:50px;'>
        <el-form-item label="角色名称" prop="name">
          <el-input v-model="temp.roleName"></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="name">
          <el-input v-model="temp.remark"></el-input>
        </el-form-item>
        <!--<el-form-item label="创建者ID" prop="name">-->
          <!--<el-input v-model="temp.createUserId"></el-input>-->
        <!--</el-form-item>-->
<!--        <el-form-item   label="部门ID" prop="name">-->
<!--          <el-input v-model="temp.deptId"></el-input>-->
<!--        </el-form-item>-->


        <el-form-item  label="权限"   prop="perms">
          <el-tree
            default-expand-all
            ref="permsTree"
            :data="perms"
            show-checkbox
            node-key="menuId"
            :props="defaultProps">
          </el-tree>
        </el-form-item>
        <el-form-item label="创建时间" prop="date">
          <el-date-picker v-model="temp.createTime" type="datetime"
                          value-format="yyyy-MM-dd HH:mm:ss" placeholder="创建时间">
          </el-date-picker>
        </el-form-item>



      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeDialogForm">取消</el-button>
        <el-button v-if="dialogStatus=='create'" type="primary" @click="createData">确认</el-button>
        <el-button v-else type="primary" @click="updateData">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<style type="stylus">
  .filter-container {
    padding-bottom: 20px;
  }
</style>

<script>
  import { list, save, update, remove, getPerms, info } from '../../../api/sys_role'
  import waves from '@/directive/waves' // 水波纹指令
  import { parseTime } from '@/utils'


  export default {
    name: 'test',
    directives: {
      waves
    },
    data() {
      return {
        perms: null, // 权限
        defaultProps: {
          children: 'list',
          label: 'name'
        },
        tableKey: 0,
        list: null,
        total: null,
        listLoading: true,
        listQuery: {
          page: 1,
          limit: 20,
          sidx: 'role_id',
          order: 'desc',
          roleName: null,
          remark: null,
          createUserId: null,
          deptId: null,
          createTime: null
        },
        temp:
          {
            roleId: null, roleName: null, remark: null, createUserId: null, createTime: null, deptId: null, menuIdList: []
          },
        dialogFormVisible: false,
        dialogStatus:
          '',
        textMap:
          {
            update: '修改',
            create:
              '新增'
          },
        rules:
          {
            roleName: [
              {
                required: false, message:
                  '必填字段', trigger:
                  'change'
              }
            ],
            remark: [
              {
                required: false, message:
                  '必填字段', trigger:
                  'change'
              }
            ],
            createUserId: [
              {
                required: false, message:
                  '必填字段', trigger:
                  'change'
              }
            ],
            createTime: [
              {
                required: false, message:
                  '必填字段', trigger:
                  'change'
              }
            ],
            deptId: [
              {
                required: false, message:
                  '必填字段', trigger:
                  'change'
              }
            ]
          },
        downloadLoading: false,
        qData:
          {
            token: '',
            key:
              ''
          }
      }
    },
    created() {
      this.getList()
      this.getPerms()
    },
    methods: {
      parseTime(time){
        return  parseTime(time)
      },
      beforeFormShow(row) { // 表单打开之前
        this.resetTemp(row) // 更新数据
      },
      afterFormShow(row) {
        this.setPermsToTree(row) // 显示用户有的权限
      },
      beforeCommit() { // 数据提交之前
        this.getPermsFromTree() // 获取用户选择的权限
      },
      getPermsFromTree() {
        this.temp.menuIdList = this.$refs.permsTree.getCheckedKeys()
      },
      setPermsToTree(row) {
        // 清除
        this.$refs.permsTree.setCheckedKeys([])
        if (row) {
          info(row.roleId).then(res => {
            this.temp = res.data
            this.$refs.permsTree.setCheckedKeys(this.temp.menuIdList)
          })
        }
      },
      getPerms() { // 获取权限  Create,Update之前调用
        // this.perms = []
        getPerms().then(res => {
          this.perms = res.data
        })
      },
      getList() {
        this.listLoading = true
        // 如果存在时间
        if (this.listQuery.createTime) {
          this.listQuery['createTimeStart'] = parseTime(this.listQuery.createTime[0])
          this.listQuery['createTimeEnd'] = parseTime(this.listQuery.createTime[1])
        } else {
          this.listQuery['createTimeStart'] = null
          this.listQuery['createTimeEnd'] = null
        }
        list(this.listQuery).then(response => {
          this.list = response.data.list
          this.total = response.data.total
          this.listLoading = false
        })
      },
      handleFilter() {
        this.listQuery.page = 1
        this.getList()
      },
      handleSizeChange(val) {
        this.listQuery.limit = val
        this.getList()
      },
      handleCurrentChange(val) {
        this.listQuery.page = val
        this.getList()
      },
      handleModifyStatus(row, status) {
        this.$message({
          message: '操作成功',
          type: 'success'
        })
        row.status = status
      },
      resetTemp(row) {
        this.temp = {}
        if (row) {
          this.temp = Object.assign({}, row) // copy obj
        }
      },
      handleCreate() {
        // 存在图片
        this.beforeFormShow()
        this.dialogStatus = 'create'
        this.dialogFormVisible = true
        this.$nextTick(() => {
          this.afterFormShow()
          this.$refs['dataForm'].clearValidate()
        })
      },
      handleDelete(row) {
        this.beforeFormShow(row)
        this.$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          // this.$message({
          //   type: 'success',
          //   message: '删除成功!'
          // })
          this.deleteData()
        })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除'
            })
          })
      },
      createData() {
        this.beforeCommit()
        this.$refs['dataForm'].validate((valid) => {
          if (valid) {
            save(this.temp).then(res => {
              this.temp = res.data
              this.list.unshift(this.temp)
              this.closeDialogForm()
              this.$notify({
                title: '成功',
                message: '创建成功',
                type: 'success',
                duration: 2000
              })
            })
          }
        }
        )
      },
      deleteData() {
        const roleIds = [this.temp.roleId]
        remove({roleIds}).then(res => {
          // 从当前队列中移除
          for (const v of this.list
          ) {
            if (v.roleId === this.temp.roleId) {
              const index = this.list.indexOf(v)
              this.list.splice(index, 1)
              break
            }
          }
          this.$notify({
            title: '成功',
            message: '删除成功',
            type: 'success',
            duration: 2000
          })
        })
      },
      handleUpdate(row) {
        // this.getPerms()
        this.beforeFormShow(row)
        this.dialogStatus = 'update'
        this.dialogFormVisible = true
        // this.afterFormShow(row)
        this.$nextTick(() => {
          this.afterFormShow(row)
          this.$refs['dataForm'].clearValidate()
        })
      },
      updateData() {
        this.beforeCommit()
        this.$refs['dataForm'].validate((valid) => {
          if (valid) {
            const tempData = Object.assign({}, this.temp)
            update(tempData).then(() => {
              for (const v of this.list
              ) {
                if (v.roleId === this.temp.roleId) {
                  const index = this.list.indexOf(v)
                  this.list.splice(index, 1, this.temp)
                  break
                }
              }
              this.closeDialogForm()
              this.$notify({
                title: '成功',
                message: '更新成功',
                type: 'success',
                duration: 2000
              })
            })
          }
        }
        )
      },
      closeDialogForm() {
        this.dialogFormVisible = false
      },
      handleDownload() {
        this.downloadLoading = true
        import('@/vendor/Export2Excel').then(excel => {
          const tHeader = [
            '序号',
            '角色名称',
            '备注',
            '创建者ID',
            '部门ID',
            '创建时间'
          ]
          const filterVal = ['id',
            'roleName',
            'remark',
            'createUserId',
            'deptId',
            'createTime'
          ]
          const data = this.formatJson(filterVal, this.list)
          excel.export_json_to_excel({
            header: tHeader,
            data,
            filename: 'table-list'
          })
          this.downloadLoading = false
        })
      },
      formatJson(filterVal, jsonData) {
        return jsonData.map(v => filterVal.map(j => {
          return v[j]
        }
        ))
      }
    }
  }
</script>
